<script>
    import l from "./utils/locale";

    export let name;
    export let isChecked = false;
</script>

<div class="menu-draw-icon">
    {#if name === "upload"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>{l["add_image"]} (I)</title><path
                d="M416 64H96a64.07 64.07 0 00-64 64v256a64.07 64.07 0 0064 64h320a64.07 64.07 0 0064-64V128a64.07 64.07 0 00-64-64zm-80 64a48 48 0 11-48 48 48.05 48.05 0 0148-48zM96 416a32 32 0 01-32-32v-67.63l94.84-84.3a48.06 48.06 0 0165.8 1.9l64.95 64.81L172.37 416zm352-32a32 32 0 01-32 32H217.63l121.42-121.42a47.72 47.72 0 0161.64-.16L448 333.84z"
            /></svg
        >
    {:else if name === "cursor"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
        >
            <title>{l["select"]} (V)</title>
            <path
                d="M404.033,286.827c0,0-2.006-23.447-17.408-36.325c-8.607-7.291-16.847-8.24-22.692-7.679v44.091
        h-10.548v-48.297c-3.149-6.838-9.448-17.408-19.457-21.377c-9.966-4.012-20.169-3.02-26.424-1.812v49.764h-10.505v-55.868
        c-4.465-5.371-12.49-11.778-26.554-12.619c-7.593-0.453-14.366,2.61-19.716,5.975l-1.035,47.822h-10.57l0.324-86.822
        c34.082-10.678,58.996-42.128,58.996-79.769C298.423,37.555,260.847,0,214.513,0c-46.356,0-83.91,37.555-83.91,83.932
        c0,36.282,23.102,66.913,55.329,78.626v147.35c0,0-27.136-58.392-50.195-66.093c-23.016-7.679-37.339,6.148-37.339,6.148
        s26.144,48.448,45.32,102.159c12.317,34.556,16.006,74.613,26.877,94.458c27.632,50.713,62.922,55.976,105.503,55.976
        c42.494,0,100.304,3.947,115.663-31.407C407.14,435.838,404.033,286.827,404.033,286.827z M166.712,83.889
        c0-26.381,21.398-47.801,47.801-47.801c26.381,0,47.801,21.42,47.801,47.801c0,17.192-9.146,32.097-22.714,40.531l0.108-30.911
        c0,0-6.191-32.184-26.122-32.184c-19.996,0-27.632,27.611-27.632,27.611v33.068C174.348,113.311,166.712,99.549,166.712,83.889z"
            /></svg
        >
    {:else if name === "line"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
        >
            <title>{l["line"]} (5)</title>
            <path
                fill="white"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="84"
                d="M400 256H112"
            />
        </svg>
    {:else if name === "circle"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
        >
            <title>{l["circle"]} (2)</title>
            <path
                d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
                fill="white"
                stroke="currentColor"
                stroke-miterlimit="10"
                stroke-width="32"
            />
        </svg>
    {:else if name === "triangle"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
        >
            <title>{l["triangle"]} (3)</title>
            <path
                fill="white"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                d="M48 448L256 64l208 384H48z"
            />
        </svg>
    {:else if name === "brush"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>{l["brush"]} (B)</title><path
                d="M233.15 360.11a15.7 15.7 0 01-4.92-.77 16 16 0 01-10.92-13c-2.15-15-19.95-32.46-36.62-35.85a16 16 0 01-8.69-26.33l211.09-235.1c.19-.22.39-.43.59-.63a56.57 56.57 0 0179.89 0 56.51 56.51 0 01.11 79.78l-219 227a16 16 0 01-11.53 4.9zM119.89 480.11c-32.14 0-65.45-16.89-84.85-43a16 16 0 0112.85-25.54c5.34 0 20-4.87 20-20.57 0-39.07 31.4-70.86 70-70.86s70 31.79 70 70.86c0 49.12-39.48 89.11-88 89.11z"
            /></svg
        >
    {:else if name === "star"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>{l["custom_shape"]} (4)</title><path
                d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"
            /></svg
        >
    {:else if name === "square"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            class:activeIcon={isChecked}
            ><title>{l["square"]} (1)</title><path
                d="M416 464H96a48.05 48.05 0 01-48-48V96a48.05 48.05 0 0148-48h320a48.05 48.05 0 0148 48v320a48.05 48.05 0 01-48 48z"
            /></svg
        >
    {:else if name === "text"}
        <svg
            class:activeIcon={isChecked}
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["text"]} (T)</title><path
                d="M292.6 407.78l-120-320a22 22 0 00-41.2 0l-120 320a22 22 0 0041.2 15.44l36.16-96.42a2 2 0 011.87-1.3h122.74a2 2 0 011.87 1.3l36.16 96.42a22 22 0 0041.2-15.44zm-185.84-129l43.37-115.65a2 2 0 013.74 0l43.37 115.67a2 2 0 01-1.87 2.7h-86.74a2 2 0 01-1.87-2.7zM400.77 169.5c-41.72-.3-79.08 23.87-95 61.4a22 22 0 0040.5 17.2c8.88-20.89 29.77-34.44 53.32-34.6 32.32-.22 58.41 26.5 58.41 58.85a1.5 1.5 0 01-1.45 1.5c-21.92.61-47.92 2.07-71.12 4.8-54.75 6.44-87.43 36.29-87.43 79.85 0 23.19 8.76 44 24.67 58.68C337.6 430.93 358 438.5 380 438.5c31 0 57.69-8 77.94-23.22h.06a22 22 0 1044 .19v-143c0-56.18-45-102.56-101.23-102.97zM380 394.5c-17.53 0-38-9.43-38-36 0-10.67 3.83-18.14 12.43-24.23 8.37-5.93 21.2-10.16 36.14-11.92 21.12-2.49 44.82-3.86 65.14-4.47a2 2 0 012 2.1C455 370.1 429.46 394.5 380 394.5z"
            /></svg
        >
    {:else if name === "clear"}
        <svg
            class:activeIcon={isChecked}
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["remove_selected_object"]}</title><path
                d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"
            /></svg
        >
        <!-- {:else if name === "triangle"}
        <svg
            class:activeIcon={isChecked}
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>Triangle</title><path
                d="M464 464H48a16 16 0 01-14.07-23.62l208-384a16 16 0 0128.14 0l208 384A16 16 0 01464 464z"
            /></svg
        > -->
        <!-- {:else if name === "square"}
        <svg
            class:activeIcon={isChecked}
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>Square</title><path
                d="M416 464H96a48.05 48.05 0 01-48-48V96a48.05 48.05 0 0148-48h320a48.05 48.05 0 0148 48v320a48.05 48.05 0 01-48 48z"
            /></svg
        >
    {:else if name === "star"}
        <svg
            class:activeIcon={isChecked}
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>Polygon</title><path
                d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"
            /></svg
        > -->
    {:else if name === "save-preset"}
        <svg
            class:activeIcon={isChecked}
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["save_drawing"]} (S)</title><path
                d="M465.94 119.76l-73.7-73.7A47.68 47.68 0 00358.3 32H96a64 64 0 00-64 64v320a64 64 0 0064 64h320a64 64 0 0064-64V153.7a47.68 47.68 0 00-14.06-33.94zM120 112h176a8 8 0 018 8v48a8 8 0 01-8 8H120a8 8 0 01-8-8v-48a8 8 0 018-8zm139.75 319.91a80 80 0 1176.16-76.16 80.06 80.06 0 01-76.16 76.16z"
            /><circle cx="256" cy="352" r="48" />
        </svg>
    {:else if name === "load-preset"}
        <svg
            class:activeIcon={isChecked}
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["apply_drawing"]} (P)</title>
            <path
                d="M336 336H32a16 16 0 01-14-23.81l152-272a16 16 0 0127.94 0l152 272A16 16 0 01336 336z"
            /><path
                d="M336 160a161.07 161.07 0 00-32.57 3.32l74.47 133.27A48 48 0 01336 368H183.33A160 160 0 10336 160z"
            />
        </svg>
    {:else if name === "forward"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["forward_selected_object"]}</title>
            <path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="48"
                d="M112 244l144-144 144 144M256 120v292"
            />
        </svg>
    {:else if name === "backward"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["backward_selected_object"]}</title>
            <path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="48"
                d="M112 268l144 144 144-144M256 392V100"
            />
        </svg>
    {:else if name === "screenshot"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["make_screenshot"]}</title>
            <path
                d="M376 160H272v153.37l52.69-52.68a16 16 0 0122.62 22.62l-80 80a16 16 0 01-22.62 0l-80-80a16 16 0 0122.62-22.62L240 313.37V160H136a56.06 56.06 0 00-56 56v208a56.06 56.06 0 0056 56h240a56.06 56.06 0 0056-56V216a56.06 56.06 0 00-56-56zM272 48a16 16 0 00-32 0v112h32z"
            />
        </svg>
    {:else if name === "undo"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["undo"]} (Delete)</title>
            <path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="48"
                d="M244 400L100 256l144-144M120 256h292"
            />
        </svg>
    {:else if name === "eraser"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["eraser"]}</title>
            <path
                d="M290 32H144a64.07 64.07 0 00-64 64v320a64.07 64.07 0 0064 64h146zM368 32h-18v448h18a64.07 64.07 0 0064-64V96a64.07 64.07 0 00-64-64z"
            />
        </svg>
    {:else if name === "add_to_db"}
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            ><title>{l["add"]}</title><path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="32"
                d="M256 112v288M400 256H112"
            /></svg
        >
        {:else if name === "copy"}
        <svg
        xmlns="http://www.w3.org/2000/svg"
        class="ionicon"
        viewBox="0 0 512 512"
        ><title>{l["copy"]} (C)</title>
        <path d="M408 480H184a72 72 0 01-72-72V184a72 72 0 0172-72h224a72 72 0 0172 72v224a72 72 0 01-72 72z"/><path d="M160 80h235.88A72.12 72.12 0 00328 32H104a72 72 0 00-72 72v224a72.12 72.12 0 0048 67.88V160a80 80 0 0180-80z"/></svg
        >
        {:else if name === "layer"}
        <svg
        xmlns="http://www.w3.org/2000/svg"
        class="ionicon"
        viewBox="0 0 512 512"
        ><title>{l["layer"]} (L)</title>
        <title>Layers</title><path d="M256 256c-13.47 0-26.94-2.39-37.44-7.17l-148-67.49C63.79 178.26 48 169.25 48 152.24s15.79-26 22.58-29.12l149.28-68.07c20.57-9.4 51.61-9.4 72.19 0l149.37 68.07c6.79 3.09 22.58 12.1 22.58 29.12s-15.79 26-22.58 29.11l-148 67.48C282.94 253.61 269.47 256 256 256zm176.76-100.86z"/><path d="M441.36 226.81L426.27 220l-38.77 17.74-94 43c-10.5 4.8-24 7.19-37.44 7.19s-26.93-2.39-37.42-7.19l-94.07-43L85.79 220l-15.22 6.84C63.79 229.93 48 239 48 256s15.79 26.08 22.56 29.17l148 67.63C229 357.6 242.49 360 256 360s26.94-2.4 37.44-7.19l147.87-67.61c6.81-3.09 22.69-12.11 22.69-29.2s-15.77-26.07-22.64-29.19z"/><path d="M441.36 330.8l-15.09-6.8-38.77 17.73-94 42.95c-10.5 4.78-24 7.18-37.44 7.18s-26.93-2.39-37.42-7.18l-94.07-43L85.79 324l-15.22 6.84C63.79 333.93 48 343 48 360s15.79 26.07 22.56 29.15l148 67.59C229 461.52 242.54 464 256 464s26.88-2.48 37.38-7.27l147.92-67.57c6.82-3.08 22.7-12.1 22.7-29.16s-15.77-26.07-22.64-29.2z"/></svg
    >
    {/if}
</div>
